export enum OrderDetailsView {
  DINING_OPTION = 'dining-option',
  DESTINATION = 'destination',
  GUEST = 'guest',
}

export enum OrderSortKey {
  ORDER_NUMBER = 'orderNumber',
  GUEST_NAME = 'name',
}

export enum OrderFilterKey {
  SHIFT_ID = 'shiftId',
  GUEST_NAME = 'guestName',
  /** 'paid' | 'unpaid' | 'missing-payment' */
  PAYMENT_STATUS = 'paymentStatus',
  /** 'TABLE' | 'TAB' | 'EVENT' | 'FAST_CLOSE' | etc. – matches DiningOptionsBehavior */
  ORDER_TYPE = 'orderType',
  /** 'today' | 'last24h' | 'all' */
  TIME_RANGE = 'timeRange',
  /** 'card-on-file' – only orders with card on file */
  CARD_ON_FILE = 'cardOnFile',
}
